<template>
  <div class="dynamic-field-container">
    <label>{{ field.label }}</label>
    <el-tag
      :key="tag"
      :data-vv-as="fieldName"
      v-validate="fieldValidationRules"
      v-model="proxyValue"
      v-for="tag in tags.dynamicTags"
      type="primary"
      :closable="true"
      :close-transition="false"
      @close="handleClose(tag)"
      :disabled="isTaskFieldDisabled">
      {{tag}}
    </el-tag>
    <input type="text" placeholder="Add new tag" class="form-control input-new-tag"
           v-model="tags.inputValue"
           ref="saveTagInput"
           size="mini"
           @keyup.enter="handleInputConfirm"
           :disabled="isTaskFieldDisabled"
           @blur="handleInputConfirm"/>
  </div>
</template>

<script>
  import {Tag} from 'element-ui'
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    components: {
      [Tag.name]: Tag
    },
    computed: {
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        fieldValidation: {},
        tags: {
          dynamicTags: [],
          inputVisible: false,
          inputValue: '',
          statusOnLoad: null
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      handleClose(tag) {
        this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1)
      },
      handleInputConfirm() {
        let inputValue = this.tags.inputValue
        if (inputValue) {
          this.tags.dynamicTags.push(inputValue)
        }
        this.tags.inputVisible = false
        this.tags.inputValue = ''
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
  }
</style>
